import clsx from "clsx";
import sanitizedData from "@/core/helpers/sanitizedData";
import { BaseIcon } from "@/shared/icons/BaseIcon";

type Props = {
  color: string;
  text: string;
  icon?: typeof BaseIcon;
};

export default function NotificationsActionBody({ color, text, icon }: Props) {
  return (
    <div className="relative w-[16.875rem] p-0 bg-gradient-to-r from-dark-900/60 to-dark-900/80 rounded-xl overflow-hidden pointer-events-auto">
      <div
        className="relarive size-full px-[0.75rem] py-[0.625rem] bg-gradient-to-r rounded-lg"
        style={{
          background: `linear-gradient(90deg, ${color}33 0%, ${color}05 100%)`,
        }}
      >
        <div className="flex items-center gap-[0.625rem]">
          {icon && icon({ size: 20, color, className: "shrink-0" })}
          <p className="text-14 font-medium" dangerouslySetInnerHTML={sanitizedData(text)} />
        </div>
      </div>
      <span
        className={clsx(
          "absolute top-0 left-0 w-[calc(100%-0.125rem)] h-[calc(100%-0.250rem)] border-transparent border-l-[0.125rem] rounded-lg mask-padding",
        )}
        style={{
          background: `linear-gradient(transparent, ${color}40, ${color}, ${color}40, transparent)`,
        }}
      />
    </div>
  );
}
